import axios from 'axios';
import '/src/services/axios-interceptor';
import authHeader from '/src/services/auth-header';
const API_URL = process.env.VUE_APP_BASE_URL_API + '/workspace/';
const API_URL_CNT = process.env.VUE_APP_BASE_URL_API + '/wspcontent/';
const API_URL_FRM = process.env.VUE_APP_BASE_URL_API + '/wspform/';
const API_URL_V310 = process.env.VUE_APP_BASE_URL_API + '/voucher310/';

class WorkSpaceService {
   // Board
   getBoard(boardId) {
      return axios.get(API_URL + `getboard/${boardId}`, { headers: authHeader() });
   }

   getBoardRectangle(boardId) {
      return axios.get(API_URL + `getboardrectangle/${boardId}`, { headers: authHeader() });
   }

   findContentByString(boardId, itemsByPage, start, searchText, searchOption, searchOrder, filterBoardId) {
      return axios.post(API_URL + 'findcontentbystring', {
         boardId: boardId,
         itemsByPage: itemsByPage,
         start: start,
         searchText: searchText,
         searchOption: searchOption,
         searchOrder: searchOrder,
         filterBoardId: filterBoardId
         },
         { headers: authHeader() }
      );
   }

   findMyBoards( userId ) {
      return axios.get(API_URL + `find_my_boards/${userId}`, { headers: authHeader() });
   }
   // Cell
   getCellByPosition(
         boardId, 
         rowPosition, 
         columnPosition, 
         field, 
         order, 
         pageNumber,
         filterCardTypeId,
         filterUserId,
         filterLabelId
         ) {
      let cellParams = {
         boardId: boardId,
         rowPosition: rowPosition,
         columnPosition: columnPosition,
         field: field,
         order: order,
         pageNumber: pageNumber,
         filterCardTypeId: filterCardTypeId,
         filterUserId: filterUserId,
         filterLabelId: filterLabelId
         }
      return axios.post(API_URL + 'getcellbyposition', cellParams, {headers: authHeader()});
   }

   getCellMilli(cellId) {
      return axios.get(API_URL + `getcellmilli/${cellId}`,  { headers: authHeader() });
   }

   getCell(cellId) {
      return axios.get(API_URL + `getcell/${cellId}`,  { headers: authHeader() });
   }

   getCellsByBoard(boardId) {
      return axios.get(API_URL + `getcellsbyboard/${boardId}`,  { headers: authHeader() });
   }

   changePosition(cellContentId, cellId, oldIndex, newIndex, field, order) {
      return axios.post(API_URL + 'changeposition', {
            cellContentId: cellContentId,
            cellId: cellId,
            oldIndex: oldIndex,
            newIndex: newIndex,
            field: field,
            order: order
         },
         { headers: authHeader() }
      );
   }

   getCellContent(cellId, contentId) {
      return axios.get(
         API_URL + 'getcellcontent',
         {
            params: {
               cellId: cellId,
               contentId: contentId
            },
            headers: authHeader()
         }
      );
   }

   getBoardsTo(boardId, cardTypeId, contentId, moveShared) {
      return axios.get(
         API_URL + 'getboardstomoveshared',
         {
            params: {
               boardId: boardId,
               cardTypeId: cardTypeId,
               contentId: contentId,
               moveShared: moveShared
            },
            headers: authHeader()
         }
      );
   }

   getCellByContentIdAndBoardId(contentId, boardId) {
      return axios.get(
         API_URL + 'getcellbycontentidandboardid',
         {
            params: {
               contentId: contentId,
               boardId: boardId
            },
            headers: authHeader()
         }
      );
   }
   // Content
   newContent(content) {
      return axios.post(API_URL + 'newcontent', {
            name: content.name,
            columnId: content.columnId
         },
         { headers: authHeader() }
      );
   }

   addAuditContent(contentId, codeAudit, userId, text, cellId, userAppModuleId, boardId) {
      return axios.post(API_URL_CNT + 'addaudit', {
            contentId: contentId,
            codeAudit: codeAudit,
            userId: userId,
            text: text,
            cellId: cellId,
            userAppModuleId: userAppModuleId,
            boardId: boardId
         },
         { headers: authHeader() }
      );
   }

   addAuditMoveOrShared(
         contentId, 
         codeAudit, 
         userId, 
         text, 
         cellId, 
         boardId, 
         boardIdTo, 
         cellLabelIdTo,
         moveShare
         ) {
      return axios.post(API_URL_CNT + 'addauditmoveorshared', {
            contentId: contentId,
            codeAudit: codeAudit,
            userId: userId,
            text: text,
            cellId: cellId,
            boardId: boardId,
            boardIdTo: boardIdTo,
            cellLabelIdTo: cellLabelIdTo,
            moveShare: moveShare
         },
         { headers: authHeader() }
      );
   }

   unshareAll( contentId, userId ) {
      console.log(contentId)
      return axios.post(API_URL_CNT + 'unshare_all', { 
         contentId: contentId,
         userId: userId
       },
         { headers: authHeader() }
      );
   }

   getShowMoveShare( boardId, contentId, cellId ) {
      return axios.get(API_URL_CNT + 'getshowmoveshare', 
         { 
            params: {
               boardId: boardId,
               contentId: contentId,
               cellId: cellId
            },
            headers: authHeader() 
         });
   }

   getAllBoards(boardId, userId, contentId) {
      return axios.get(API_URL_CNT + 'getallboards', 
         { 
            params: {
               boardId: boardId,
               userId: userId,
               contentId: contentId
            },
            headers: authHeader() 
         });
   }

   getUsers(boardId, contentId) {
      return axios.get(
         API_URL_CNT + 'getusers',
         {
            params: {
               boardId: boardId,
               contentId: contentId
            },
            headers: authHeader()
         }
      );
   }

   getBoardCardTypes(boardId) {
      return axios.get(API_URL_CNT + `getboardcardTypes/${boardId}`,  { headers: authHeader() });
   }

   getBoardLabels(boardId) {
      return axios.get(API_URL_CNT + `getboardlabels/${boardId}`,  { headers: authHeader() });
   }

   getMyLabel(labelId) {
      return axios.get(API_URL_CNT + `getmylabel/${labelId}`,  { headers: authHeader() });
   }

   getContent(contentId) {
      return axios.get(API_URL_CNT + `getcontent/${contentId}`,  { headers: authHeader() });
   }

   getDataToAddContent(cardTypeId) {
      return axios.get(API_URL_CNT + `getdatatoaddcontent/${cardTypeId}`,  { headers: authHeader() });
   }
   /*
   getDataToCopy(contentId) {
      return axios.get(API_URL_CNT + `getdatatocopy/${contentId}`,  { headers: authHeader() });
   }
   */
   getDataToCopy(boardId, contentId) {
      return axios.get(
         API_URL_CNT + 'getdatatocopy',
         {
            params: {
               boardId: boardId,
               contentId: contentId
            },
            headers: authHeader()
         }
      );
   }
   /*
   getContentAudit(contentId, auditTypeId) {
      let arrLong = [contentId, auditTypeId];
      return axios.get(API_URL_CNT + `getcontentaudit/${arrLong}`,  { headers: authHeader() });
   }
   */
   getContentAudit(boardId, contentId, auditTypeId) {
      return axios.get(
         API_URL_CNT + 'getcontentaudit',
         {
            params: {
               boardId: boardId,
               contentId: contentId,
               auditTypeId: auditTypeId
            },
            headers: authHeader()
         }
      );
   }

   getMembersNotInCard(userAppModuleId, contentId, boardId) {
      return axios.get(
         API_URL_CNT + 'getmembersnotincard',
         {
            params: {
               userAppModuleId: userAppModuleId,
               contentId: contentId,
               boardId: boardId
            },
            headers: authHeader()
         }
      );
   }

   getAppMembers(userAppModuleId, contentId, showAll) {
      return axios.get(
         API_URL_CNT + 'getappmembers',
         {
            params: {
               userAppModuleId: userAppModuleId,
               contentId: contentId,
               showAll: showAll
            },
            headers: authHeader()
         }
      );
   }

   getBoardMembers( boardId ) {
      return axios.get(
         API_URL_CNT + 'getboardmembers',
         {
            params: {
               boardId: boardId
            },
            headers: authHeader()
         }
      );
   }

   addMembersToCard(userIds, contentId, userId, cellId, boardId) {
      return axios.post(API_URL_CNT + 'addmemberstocard', {
            userIds: userIds,
            contentId: contentId,
            userId: userId,
            cellId: cellId,
            boardId: boardId
         },
         { headers: authHeader() }
      );
   }

   onOffCheckList(checkListId, contentId) {
      return axios.post(API_URL_CNT + 'onoffchecklist', {
            checkListId: checkListId,
            contentId: contentId
         },
         { headers: authHeader() }
      );
   }

   upDataToCopy(dataToCopy) {
      return axios.post(API_URL_CNT + 'updatatocopy', dataToCopy.value, { headers: authHeader() });
   }

   getMyCircle(userId) {
      return axios.get(API_URL_CNT + `getmycircle/${userId}`,  { headers: authHeader() });
   }

   getMyCardRectangle(cardTypeId) {
      return axios.get(API_URL_CNT + `getmycardrectangle/${cardTypeId}`,  { headers: authHeader() });
   }

   getColors(type) {
      return axios.get(API_URL_CNT + `getcolors/${type}`,  { headers: authHeader() });
   }
   /*
   getCheckList(contentId) {
      return axios.get(API_URL_CNT + `getchecklist/${contentId}`,  { headers: authHeader() });
   }
   */
   getCheckList(boardId, cardTypeId, contentId) {
      return axios.get(
         API_URL_CNT + 'getchecklist',
         {
            params: {
               boardId: boardId,
               cardTypeId: cardTypeId,
               contentId: contentId
            },
            headers: authHeader()
         }
      );
   }

   addContent(
      userId,
      boardId, 
      cellId,
      cardTypeId,
      title
      ) {
         return axios.post(API_URL_CNT + 'addcontent', {
            userId: userId,
            boardId: boardId,
            cellId: cellId,
            cardTypeId: cardTypeId,
            title: title },
            { headers: authHeader() }
         );
      }

   upContent(
         contentId, 
         cellId,
         boardId,
         code,
         cnttData
         ) {

      let columnId = null
      let userId = null
      let title = null
      let fpColorId = null
      let labelId = null
      let enableDates = null
      let startDate = null
      let endDate = null
      let okDate = null
      let upDescription = null
      let description = null
      let enableCheckList = null
      let contentCheckListControlId = null
      let checkListControlId = null
      let deletAttachId = null
      let putOffAttachId = null
      let retrieveAttachId = null

      if (code == 'TTL') {
         columnId = cnttData.columnId
         userId = cnttData.userId
         title = cnttData.title
      }
      if (code == 'FPC') {
         fpColorId = cnttData.fpColorId
      }
      if (code == 'LBL') {
         labelId = cnttData.labelId
         userId = cnttData.userId
      }
      if (code == 'DTS') {
         enableDates = cnttData.enableDates
         startDate = cnttData.startDate
         endDate = cnttData.endDate
         userId = cnttData.userId
      }
      if (code == 'DTK') {
         okDate = cnttData.okDate
         userId = cnttData.userId
      }
      if (code == 'DSC') {
         upDescription = true
         description = cnttData.description
      }
      if (code == 'CHL') {
         enableCheckList = cnttData.enableCheckList
         userId = cnttData.userId
      }
      if (code == 'CRL') {
         userId = cnttData.userId
         contentCheckListControlId = cnttData.contentCheckListControlId
         checkListControlId = cnttData.checkListControlId
      }
      if (code == 'ATD') {
         deletAttachId = cnttData.deletAttachId
         userId = cnttData.userId
      }
      if (code == 'ATP') {
         putOffAttachId = cnttData.putOffAttachId
         userId = cnttData.userId
      }
      if (code == 'ATR') {
         retrieveAttachId = cnttData.retrieveAttachId
         userId = cnttData.userId
      }
      return axios.post(API_URL_CNT + 'upcontent', {
            contentId: contentId,
            cellId: cellId,
            boardId: boardId,
            columnId: columnId,
            userId: userId,
            title: title,
            frontPageColorId: fpColorId,
            labelId: labelId,
            enableDates: enableDates,
            startDate: startDate,
            endDate: endDate,
            okDate: okDate,
            upDescription: upDescription,
            description: description,
            enableCheckList: enableCheckList,
            contentCheckListControlId: contentCheckListControlId,
            checkListControlId: checkListControlId,
            deletAttachId: deletAttachId,
            putOffAttachId: putOffAttachId,
            retrieveAttachId: retrieveAttachId
                        },
         { headers: authHeader() }
      );
   }
   /*
   getAllLabels(contentId) {
      return axios.get(API_URL_CNT + `getalllabels/${contentId}`,  { headers: authHeader() });
   }
   */
   getAllLabels(boardId, cardTypeId, contentId) {
      return axios.get(
         API_URL_CNT + 'getalllabels',
         {
            params: {
               boardId: boardId,
               cardTypeId: cardTypeId,
               contentId: contentId
            },
            headers: authHeader()
         }
      );
   }

   getDescriptions(boardId, contentId) {
      return axios.get(
         API_URL_CNT + 'getdescriptions',
         {
            params: {
               boardId: boardId,
               contentId: contentId
            },
            headers: authHeader()
         }
      );
   }
   /*
   getLabels(contentId) {
      return axios.get(API_URL_CNT + `getlabels/${contentId}`,  { headers: authHeader() });
   }
   */
   getLabels(boardId, contentId) {
      return axios.get(
         API_URL_CNT + 'getlabels',
         {
            params: {
               boardId: boardId,
               contentId: contentId
            },
            headers: authHeader()
         }
      );
   }

   addAttachContent(contentId, cellId, boardId, userId, attachFile) {

      const jsonCnttId = JSON.stringify(contentId);
      const blobCnttId = new Blob([jsonCnttId], {
        type: 'application/json'
      });

      const jsonCellId = JSON.stringify(cellId);
      const blobCellId = new Blob([jsonCellId], {
        type: 'application/json'
      });

      const jsonBoardId = JSON.stringify(boardId);
      const blobBoardId = new Blob([jsonBoardId], {
        type: 'application/json'
      });

      const jsonUserId = JSON.stringify(userId);
      const blobUserId = new Blob([jsonUserId], {
        type: 'application/json'
      });

      let formData = new FormData();
      formData.append("contentId", blobCnttId,);
      formData.append("cellId", blobCellId,);
      formData.append("boardId", blobBoardId,);
      formData.append("userId", blobUserId,);
      formData.append("attachFile", attachFile);
      console.log(formData)
      return axios.create({
         baseURL: API_URL_CNT,
         headers: authHeader()
      })
      .post('addattach', formData,{
         headers: {
            "Content-Type": "multipart/form-data"
         }
      })
   }
   /*
   getAttachs(contentId) {
      return axios.get(API_URL_CNT + `getattachs/${contentId}`,  { headers: authHeader() });
   }
   */
   getAttachs(boardId, contentId, putOff) {
      return axios.get(
         API_URL_CNT + 'getattachs',
         {
            params: {
               boardId: boardId,
               contentId: contentId,
               putOff: putOff
            },
            headers: authHeader()
         }
      );
   }
   upForm( upForm ) {
      return axios.post(API_URL_CNT + 'up_form', upForm,
         { headers: authHeader() }
      );
   }
   // CRUD
   getControls(ascDesc) {
      return axios.get(
         API_URL_CNT + `getcontrols`,  
         { 
            params: {
               ascDesc: ascDesc
            },
            headers: authHeader() 
         }
      );
   }

   upControl(id, type, name) {
         return axios.post(API_URL_CNT + 'upcontrol', {
            id: id,
            type: type,
            name: name
            },
         { headers: authHeader() }
      );
   }

   getCheckLists(ascDesc) {
      return axios.get(
         API_URL_CNT + `getchecklists`,  
         { 
            params: {
               ascDesc: ascDesc
            },
            headers: authHeader() 
         }
      );
   }

   upCheckList(id, name) {
      return axios.post(API_URL_CNT + 'upchecklist', {
         id: id,
         name: name
         },
         { headers: authHeader() }
      );
   }

   getControlsByCheckList(checkListId) {
      return axios.get(
         API_URL_CNT + `getcontrolsbychecklist`,  
         { 
            params: {
               checkListId: checkListId
            },
            headers: authHeader() 
         }
      );
   }

   adControl(checkListId, controlId) {
      return axios.post(API_URL_CNT + 'adcontrol', {
         checkListId: checkListId,
         controlId: controlId
         },
         { headers: authHeader() }
      );
   }

   extensionRegister( values ) {
      return axios.post(API_URL_CNT + 'extension_register', values ,
         { headers: authHeader() }
      );
   }

   orderCheckList(checkListId, controlId, upDown) {
      return axios.get(
         API_URL_CNT + `orderchecklist`,  
         { 
            params: {
               checkListId: checkListId,
               controlId: controlId,
               upDown: upDown
            },
            headers: authHeader() 
         }
      );
   }
// ??
   htmlSeparator( texto ) {
      //console.log(texto)
      let replText = texto.replaceAll("-|-", "<span style="+"color:transparent;"+">-</span>|<span style="+"color:transparent;"+">-</span>");
      return replText.replaceAll("-:-", "<span style="+"color:transparent;"+">-</span>:<span style="+"color:transparent;"+">-</span>");
   }
   sortCellsContent(boardId) {
      return axios.get(API_URL + `sortcellscontent/${boardId}`, { headers: authHeader() });
   }
   //
   getBoardId(store) {
      let uAppIndex = store.state.auth.userAppIndex;
      if (uAppIndex >= 0) {
         let uAppModule = store.state.auth.userAppModule;
         return uAppModule.appModuleComponent[uAppIndex].parameters;
      }
      return null;
   }
   //
   /*
   getBoardIdThis(uAppIndex, uAppModule) {
      if (uAppIndex >= 0) {
         return uAppModule.appModuleComponent[uAppIndex].parameters;
      }
      return null;
   }
   */
   // Form
   getFormValues( id ) {
      return axios.get(API_URL_FRM + 'get_form_values',
         { 
            params: { id: id },
            headers: authHeader() 
         }
      );
   }

   getMyCardReferences( cardTypeId, contentId ) {
      return axios.get(API_URL_FRM + 'get_my_card_references',
         { 
            params: { 
               cardTypeId: cardTypeId,
               contentId: contentId
            },
            headers: authHeader() 
         }
      );
   }
   
   getOtherEmails( analyticalType, cuil ) {
      return axios.get(API_URL_FRM + 'get_other_emails',
         { 
            params: { 
               analyticalType: analyticalType,
               cuil: cuil
            },
            headers: authHeader() 
         }
      );
   }

   updateForm( upForm ) {
      return axios.post(API_URL_FRM + 'update_form', upForm,
         { headers: authHeader() }
      );
   }
   
   getMailData( mailType, contentId, userId, bodyText, boardId, attachId ) {
      return axios.get(API_URL_FRM + 'get_mail_data',
         { 
            params: { 
               mailType: mailType,
               contentId: contentId,
               userId: userId,
               bodyText: bodyText,
               boardId: boardId,
               attachId: attachId
            },
            headers: authHeader() 
         }
      );
   }

   sendFormMail( mailType, contentId, userId, bodyText, boardId, cellId ) {
      return axios.post(API_URL_FRM + 'send_form_mail', 
         {
            mailType: mailType,
            contentId: contentId,
            userId: userId,
            bodyText: bodyText,
            boardId: boardId,
            cellId: cellId
      },
         { headers: authHeader() }
      );
   }

   attachMail( id ) {
      return axios.get(API_URL_FRM + 'attach_mail',
         { 
            params: { 
               id:id
            },
            headers: authHeader() 
         }
      );
   }
   
   existsAuthorization( contentId, authorizationNumber ) {
      return axios.get(API_URL_FRM + 'exists_authorization',
         { 
            params: { 
               contentId: contentId,
               authorizationNumber: authorizationNumber
            },
            headers: authHeader() 
         }
      );
   }

   findValidUntilDate( date ) {
      console.log(typeof( date))
      console.log(API_URL_V310)
      console.log(date)
      console.log(typeof date)
      return axios.get(
         API_URL_V310 + 'find_valid_until_date',
         {
            params: {
               date: date
            },
            headers: authHeader()
         }
      );
   }
}

export default new WorkSpaceService();